import { Controller } from 'stimulus';

import $ from 'jquery';

require("select2/dist/css/select2");
require("select2-bootstrap-theme/dist/select2-bootstrap");

import Select2 from "select2";
export default class extends Controller {
    static targets = ['form']

    connect() {
        $('.site-search').select2();

        $(".site-search").on("change", function (e) {
            // check select all else deselect
            if ($(".site-search :selected").length == $('.site-search option').length) {
                document.getElementsByClassName("checkbox_select_all")[0].checked = true;
            } else {
                document.getElementsByClassName("checkbox_select_all")[0].checked = false;
            }
        });
    }

    submit(e) {
        let isValid = this.validateform();
        if (!isValid) {
            e.preventDefault()
        }
    }

    validateform() {
        return this.validateRoles() && this.validateSiteForUploader();
    }

    validateRoles() {
        let roles = document.getElementsByClassName("checkbox_role");
        let isRoleValid = false;
        roles.forEach(role => {
            if (role.checked) {
                isRoleValid = true
            }
        });

        if (isRoleValid) {
            document.getElementById("role-error").classList.add("hidden");
        }
        else {
            document.getElementById("role-error").classList.remove("hidden");
        }

        return isRoleValid
    }

    validateSiteForUploader() {
        let site = document.getElementById("study_invitation_site_ids") || document.getElementById("study_user_site_ids");
        let isValid = true;
        let roleImageUploader = document.getElementById("study_invitation_image_uploader") || document.getElementById("study_user_image_uploader");
        let roleQC = document.getElementById("study_invitation_quality_controller") || document.getElementById("study_user_quality_controller");
        let roleGrader = document.getElementById("study_invitation_grader") || document.getElementById("study_user_grader");
        let roleAdj = document.getElementById("study_invitation_adjudicator") || document.getElementById("study_user_adjudicator");
        let roleSponsor = document.getElementById("study_invitation_sponsor") || document.getElementById("study_user_sponsor");
        if ((roleImageUploader.checked && !site.value) || (roleQC.checked && !site.value) || (roleGrader.checked && !site.value) || (roleAdj.checked && !site.value) || (roleSponsor.checked && !site.value)) {
            alert("At least one of the site needs to be selected")
            isValid = false
        }
        return isValid
    }

 roleChange(event) {
  const form = document.querySelector("[data-controller='invitation-roles']");
  const name =
  form.querySelector("input[name='study_invitation[name]']")?.value ||
  form.querySelector("input[name='study_user[name]']")?.value;
  const email =
  form.querySelector("input[name='study_invitation[email]']")?.value ||
  form.querySelector("input[name='study_user[email]']")?.value;

  if (!name || !email) {
    Swal.fire({
      icon: "warning",
      title: "Required Fields",
      text: "Name and Email are required.",
      confirmButtonText: "OK"
    }).then(() => {
      event.target.checked = false;
    });
    return;
  }

  const checkRoles = Array.from(document.getElementsByClassName("checkbox_role"));
const studyId =
  event.currentTarget.dataset.study?.trim() ||
  form.querySelector("input[name='study_user[study]']")?.value?.trim();

  const selectedRoles = checkRoles
    .filter(role => role.checked)
    .map(role => role.getAttribute("data-rolevalue"));

  // ✅ Roles that should trigger user/license validation
  const rolesToValidate = [
    "project_admin",
    "image_uploader",
    "grader",
    "quality_controller",
    "adjudicator",
    "finance_manager"
  ];

// ✅ Check if current role is in the validation list
const currentRole = event.target.getAttribute("data-rolevalue");

// Detect form mode
const isInvitation = !!form.querySelector("input[name='study_invitation[email]']");
const isExistingUser = !!form.querySelector("input[name='study_user[email]']");

// Detect if grader role was already checked before this click
const graderCheckbox = form.querySelector("input[data-rolevalue='grader']");
const wasGraderAlreadyChecked = graderCheckbox && graderCheckbox.checked && currentRole !== "grader";

// ✅ Only run validation in these cases:
if (rolesToValidate.includes(currentRole)) {
  const shouldValidate =
    isInvitation ||                       // new invite → always validate
    (isExistingUser && !wasGraderAlreadyChecked); // update → only if grader not already checked

  if (shouldValidate && selectedRoles.length > 0) {
    this.validateUserAndCertificates(selectedRoles, studyId, event);
  }
}

  // ✅ Grader-specific logic
  const isGraderSelected = selectedRoles.includes("grader");
  const isValidatorSelected = selectedRoles.includes("validator");

  if (
    currentRole === "quality_controller" ||
    currentRole === "grader"
  ) {
    this.selectAllChange("", true, isGraderSelected);
  }

  this.checkIfRoleIsPM(checkRoles);

  // ✅ Only grader and validator get modality dropdown
  if (!isGraderSelected && !isValidatorSelected) {
    this.removeModalityDropdown();
  }
}

async validateUserAndCertificates(roles, studyId, event) {
  try {
    const form = document.querySelector("[data-controller='invitation-roles']");
     const name =
      form.querySelector("input[name='study_invitation[name]']")?.value ||
      form.querySelector("input[name='study_user[name]']")?.value;
      const email =
      form.querySelector("input[name='study_invitation[email]']")?.value ||
      form.querySelector("input[name='study_user[email]']")?.value;

    const response = await fetch(`/studies/${studyId}/study_invitations/get_modalities`, {
      method: "POST",
      headers: {
        "Accept": "application/json",
        "Content-Type": "application/json",
        "X-CSRF-Token": document.querySelector("meta[name='csrf-token']").content
      },
      body: JSON.stringify({
        roles: roles,
        name: name,
        email: email,
        action_type: "pick_modality"
      })
    });

    const data = await response.json();
    console.log("Response:", data);

    // ❌ If user does not exist or missing license
    if (data.success === false) {
      Swal.fire({
        icon: "warning",
        title: data.message,
        confirmButtonColor: "#3085d6"
      }).then(() => {
        // ✅ Uncheck the role that triggered the event
        event.target.checked = false;
        this.removeModalityDropdown();
      });
      return;
    }

    // ✅ If the role is grader and modalities exist → render them
    if (roles.includes("grader") && data.modalities && data.modalities.length > 0) {
      this.renderModalityDropdown(data.modalities, studyId, email);
    } else {
      // ✅ Otherwise remove dropdown and enable invitation button
      this.removeModalityDropdown();
      const sendBtn = document.getElementById("send-invitation-btn");
       if (sendBtn) {
          sendBtn.disabled = false;
          sendBtn.classList.remove("bg-gray-300", "text-gray-600", "cursor-not-allowed", "focus:outline-none");
          sendBtn.classList.add("btn-primary");
        }
      
    }

  } catch (error) {
    console.error("Error validating user:", error);
  }
}

renderModalityDropdown(modalities, studyId, email) {
  const form = document.querySelector("[data-controller='invitation-roles']");
  let container = document.getElementById("modality-container");

  if (!container) {
    container = document.createElement("div");
    container.id = "modality-container";
    const rolesGroup = form.querySelector(".form-group:nth-of-type(3)");
    rolesGroup.insertAdjacentElement("afterend", container);
  }

  const checkboxes = modalities.map(m => `
    <div class="flex items-center space-x-2 space-y-0">
      <input 
        type="checkbox" 
        class="modality-checkbox h-3 w-3 text-blue-600 border-gray-300 rounded" 
        value="${m.id}" 
        id="modality-${m.id}">
      <label for="modality-${m.id}" class="text-gray-800">
        ${m.short_name || m.name}
      </label>
    </div>
  `).join("");

  container.innerHTML = `
    <div class="form-group mt-3">
      <label class="fw-bold d-block mb-2">Select Modalities</label>
      ${checkboxes}
      <div id="global-certificate-status" class="mt-3 fw-bold"></div>
    </div>
  `;

  const sendBtn = document.getElementById("send-invitation-btn");
 if (sendBtn) {
  sendBtn.disabled = true;
  sendBtn.classList.add("bg-gray-300", "text-gray-600", "cursor-not-allowed", "focus:outline-none");
  sendBtn.classList.remove("btn-primary");
}
  container.querySelectorAll(".modality-checkbox").forEach(checkbox => {
    checkbox.addEventListener("change", () => {
      this.checkCertificates(studyId, email);
    });
  });
}

async checkCertificates(studyId, userEmail) {
  try {
    const selected = Array.from(document.querySelectorAll(".modality-checkbox:checked"))
      .map(cb => cb.value);

    const statusContainer = document.getElementById("global-certificate-status");

    if (selected.length === 0) {
      statusContainer.innerHTML = "";     
        const sendBtn = document.getElementById("send-invitation-btn");
      if (sendBtn) {
        sendBtn.disabled = true;
        sendBtn.classList.add("bg-gray-300", "text-gray-600", "cursor-not-allowed", "focus:outline-none");
        sendBtn.classList.remove("btn-primary");
      }
      return;
    }

        let allHaveCertificates = true;
      let isMMSelected = false;
      let isNonMMSelected = false;

      for (let modalityId of selected) {
        const response = await fetch(`/studies/${studyId}/study_invitations/get_modalities`, {
          method: "POST",
          headers: { 
            "Accept": "application/json",
            "Content-Type": "application/json",
            "X-CSRF-Token": document.querySelector("meta[name='csrf-token']").content
          },
          body: JSON.stringify({
            modality_id: modalityId,
            email: userEmail,
            action_type: "check_certificate"
          })
        });

        const data = await response.json();
        console.log("Certificate check:", data);

        // 🟦 Detect MM or non-MM
        if (data.mm === true) {
          isMMSelected = true;
        } else {
          isNonMMSelected = true;
        }

        if (!data.exists) {
          allHaveCertificates = false;

          if (data.general_missing) {
            Swal.fire({
              icon: "warning",
              title: "Modality Certificate Missing",
              text: data.error || "Modality certificate does not exist.",
              confirmButtonColor: "#3085d6"
            }).then(() => {
              const box = document.getElementById(`modality-${modalityId}`);
              if (box) box.checked = false;
            });
            return;
          }
        }
      }

      // ================================
      // ✅ GLOBAL STATUS MESSAGE UPDATE
      // ================================

      // CASE 1: ONLY MM selected
      if (isMMSelected && !isNonMMSelected) {
        statusContainer.innerHTML = `<span class="text-info">ℹ️ No certificates needed</span>`;
        const sendBtn = document.getElementById("send-invitation-btn");
        if (sendBtn) {
          sendBtn.disabled = false;
          sendBtn.classList.remove("bg-gray-300", "text-gray-600", "cursor-not-allowed", "focus:outline-none");
          sendBtn.classList.add("btn-primary");
        }
        return;
      }

      // CASE 2: MM + other modalities → treat like normal
      if (allHaveCertificates) {
        statusContainer.innerHTML = `<span class="text-success">✅ All certificates are uploaded</span>`;
        const sendBtn = document.getElementById("send-invitation-btn");
        if (sendBtn) {
          sendBtn.disabled = false;
          sendBtn.classList.remove("bg-gray-300", "text-gray-600", "cursor-not-allowed", "focus:outline-none");
          sendBtn.classList.add("btn-primary");
        }
      }
      else {
      if (this.validateSiteForUploader()) {
        const form = document.querySelector("[data-controller='invitation-roles']");
        const name =
          form.querySelector("input[name='study_invitation[name]']")?.value ||
          form.querySelector("input[name='study_user[name]']")?.value;
          const email =
          form.querySelector("input[name='study_invitation[email]']")?.value ||
          form.querySelector("input[name='study_user[email]']")?.value;

        const selectedRoles = Array.from(document.querySelectorAll(".checkbox_role:checked"))
          .map(cb => cb.getAttribute("data-rolevalue"));

        let siteSelect = document.querySelector("select[name='study_invitation[site_ids][]']") || document.querySelector("select[name='study_user[site_ids][]']");
        let selectedSites = Array.from(siteSelect?.selectedOptions || []).map(opt => opt.value);

       // ✅ Also include selected modality IDs and names
        const selectedModalities = Array.from(document.querySelectorAll(".modality-checkbox:checked"))
        .map(cb => ({
            id: cb.value,
            name: cb.nextElementSibling?.innerText.trim() || ""
        }));

        const modalityNames = selectedModalities.map(m => m.name).join(",");

        // ✅ Build params including modalities
        const params = new URLSearchParams({
        name: name,
        email: email,
        roles: selectedRoles.join(","),
        sites: selectedSites.join(","),
        modality_names: modalityNames
        });

        statusContainer.innerHTML = `
          <a href="/studies/${studyId}/study_invitations/upload_certificates?${params.toString()}&page_type=study_invitation"
          onclick="setTimeout(() => location.reload(), 200);"
            class="inline-block px-3 py-1 text-sm font-medium text-white bg-primary-500 rounded hover:bg-primary-700 hover:text-white focus:outline-none no-underline">
            Upload Certificate
          </a>
        `;

        const sendBtn = document.getElementById("send-invitation-btn");
      if (sendBtn) {
        sendBtn.disabled = true;
        sendBtn.classList.add("bg-gray-300", "text-gray-600", "cursor-not-allowed", "focus:outline-none");
        sendBtn.classList.remove("btn-primary");
      }
      } else {      
        const sendBtn = document.getElementById("send-invitation-btn");
      if (sendBtn) {
        sendBtn.disabled = true;
        sendBtn.classList.add("bg-gray-300", "text-gray-600", "cursor-not-allowed", "focus:outline-none");
        sendBtn.classList.remove("btn-primary");
      }
      }
    }

  } catch (error) {
    console.error("Error checking certificates:", error);
  }
}

removeModalityDropdown() {
    const container = document.getElementById("modality-container");
    if (container) {
        container.remove();
    }
}

    checkIfRoleIsPM(checkRoles) {
    let emailNotificationCheckbox = document.getElementsByClassName(
        "checkbox_email_notification"
    )[0];
    let foundProjectAdmin = false;
    Array.from(checkRoles).forEach(role => {
        if (
        role.getAttribute("data-rolevalue") === "project_admin" &&
        role.checked
        ) {
        foundProjectAdmin = true;
        }
    });

    // Only call if checkbox exists
    if (emailNotificationCheckbox) {
        this.AutoSelectEmailNotification(foundProjectAdmin, emailNotificationCheckbox);
    }
    }

    AutoSelectEmailNotification(status, emailNotificationCheckbox) {
    if (!emailNotificationCheckbox) return; // prevent undefined error
    emailNotificationCheckbox.checked = !!status;
    }

    selectAllChange(event, role = false, roleOption) {

        const selected = role ? roleOption : document.getElementsByClassName("checkbox_select_all")[0].checked;

        $('.site-search').select2("destroy");
        $('.site-search').find('option').attr('selected', selected);
        $('.site-search').select2();

        // check select all else deselect
        if ($(".site-search :selected").length == $('.site-search option').length) {
            document.getElementsByClassName("checkbox_select_all")[0].checked = true;
        } else {
            document.getElementsByClassName("checkbox_select_all")[0].checked = false;
        }
    }

}